export default __webpack_public_path__ + "static/media/message-large.e654f388.svg";